export default (theme) => ({
  container: {
    width: '95%',
    margin: 'auto',
    marginTop: '10px'
  }
})
